import {
  SortLayout, Product,
  Categories, Invoices,
  Reports, Coupons,
  ReplyToTicket, AllFeedback,
  Appeal, Webhooks, WebhookLogs,
  InvoiceDetail, Tickets,
  LicenseDetail, Licenses,
  ProductGroups, EmbedProduct, BlackList, WhiteList,
  Utils,
  ReplyToFeedback,
  Domains, Emails,
  CustomizationStore,
  CustomizationDocumentation,
  CustomizationThemes,
  CustomizationPages,
  CustomizationNavigation,
  SubscriptionDashboard,
  Balances,
  Payouts,
  Referrals,
  FraudDashboard,
  FraudDisputes,
  FraudSecurity,
  FraudAudit,
  Subscriptions,
  SubscriptionsDetails,
  SubscriptionPlanPrice,
  Questions,
  Upselling,
  Addons,
  AppStore,
  Dashboard,
  MonthlyFees,
  AffiliateDashboard,
  AffiliateAnalyticsDetails,
  AffiliateAnalytics,
  AffiliateDashboardDetails,
  POS,
  PaymentLinks,
  PaymentLinksEdit,
  PaymentLinksAnalytic,
  EmbedIntegration,
  EmbedButtons,
  EmbedCustomization,
  EmbedStyles,
  EmbedReferrals,
  ProMembership,
  BusinessMembership,
} from '../screens';


let description = "Access your products, groups, orders, customers, fraud shield and more easily on our Web Dashboard, uniquely designed for sellers."

const dashboardRoutes = [
  {
    path: `/settings`,
    component: Addons,
    metadata: {
      title: 'Settings',
      description
    },
    exact: true,
  },
  {
    path: `/fees`,
    component: MonthlyFees,
    metadata: {
      title: 'Fees',
      description: 'View and manage your monthly fees and payments.'
    },
    exact: true,
  },
  {
    path: `/utils`,
    component: Utils,
    exact: true,
    metadata: {
      title: 'Utils',
      description
    },
  },
  {
    path: `/upselling`,
    component: Upselling,
    exact: true,
    metadata: {
      title: 'Upselling',
      description
    },
  },
  {
    path: `/addons`,
    component: Addons,
    exact: true,
    metadata: {
      title: 'Addons',
      description
    },
  },
  // {
  //   from: `/referrals`,
  //   to: `/share-and-earn`,
  //   exact: true,
  //   metadata: {
  //     title: 'Referrals',
  //     description
  //   },
  // },
  {
    path: `/customization/documentation`,
    component: CustomizationDocumentation,
    exact: true,
    metadata: {
      title: 'Customization Documentation'
    },
  },
  {
    path: `/customization/store`,
    component: CustomizationStore,
    exact: true,
    metadata: {
      title: 'Customization Store'
    },
  },
  {
    path: `/customization/themes`,
    component: CustomizationThemes,
    exact: true,
    metadata: {
      title: 'Customization Themes'
    },
  },
  {
    path: `/customization/pages`,
    component: CustomizationPages,
    exact: true,
    metadata: {
      title: 'Customization Pages'
    },
  },
  {
    path: `/customization/navigation`,
    component: CustomizationNavigation,
    exact: true,
    metadata: {
      title: 'Customization Navigation'
    },
  },
  {
    path: `/sort`,
    component: SortLayout,
    metadata: {
      title: 'Layout',
      description
    },
    exact: true,
  },
  {
    path: `/categories`,
    component: Categories,
    exact: true,
    metadata: {
      title: 'Categories',
      description
    },
  },
  {
    path: `/products`,
    component: Product,
    exact: true,
    metadata: {
      title: 'Products',
      description
    },
  },
  {
    path: `/tickets/:id`,
    component: ReplyToTicket,
    metadata: {
      title: 'Reply to Ticket',
      description
    },
  },
  {
    path: `/tickets`,
    component: Tickets,
    metadata: {
      title: 'Tickets',
      description
    },
  },
  {
    path: `/groups`,
    exact: true,
    component: ProductGroups,
    metadata: {
      title: 'Groups',
      description
    },
  },
  {
    path: `/invoices/:id`,
    component: InvoiceDetail,
    exact: true,
    metadata: {
      title: 'View Order',
      description
    },
  },
  {
    path: `/licenses/:id`,
    component: LicenseDetail,
    exact: true,
    metadata: {
      title: 'License Detail',
      description
    },
  },
  {
    path: `/licenses`,
    component: Licenses,
    exact: true,
    metadata: {
      title: 'Licenses',
      description
    },
  },
  {
    path: `/subscriptions/:id`,
    component: SubscriptionsDetails,
    exact: true,
    metadata: {
      title: 'Subscriptions Details',
      description
    },
  },
  {
    path: `/subscriptions`,
    component: Subscriptions,
    exact: true,
    metadata: {
      title: 'Subscriptions',
      description
    },
  },
  {
    path: `/links/new`,
    component: PaymentLinksEdit,
    exact: true,
    metadata: {
      title: 'Payment Links',
      description
    },
  },
  {
    path: `/links/edit/:id`,
    component: PaymentLinksEdit,
    exact: true,
    metadata: {
      title: 'Payment Links',
      description
    },
  },
  {
    path: `/links/:id`,
    component: PaymentLinksAnalytic,
    exact: true,
    metadata: {
      title: 'Payment Links',
      description
    },
  },
  {
    path: `/links`,
    component: PaymentLinks,
    exact: true,
    metadata: {
      title: 'Payment Links',
      description
    },
  },
  {
    path: `/pos`,
    component: POS,
    exact: true,
    metadata: {
      title: 'Proof of State',
      description
    },
  },
  {
    path: `/invoices`,
    component: Invoices,
    exact: true,
    metadata: {
      title: 'All Invoices',
      description
    },
  },
  {
    path: `/balances`,
    component: Balances,
    exact: true,
    metadata: {
      title: 'Balances',
      description
    },
  },
  {
    path: `/payouts`,
    component: Payouts,
    exact: true,
    metadata: {
      title: 'Payouts',
      description
    },
  },
  {
    path: `/analytics/reports`,
    component: Reports,
    exact: true,
    metadata: {
      title: 'Reports',
      description
    },
  },
  {
    path: `/analytics/stats`,
    component: Dashboard,
    exact: true,
    metadata: {
      title: 'Analytics',
      description
    }
  },
  {
    path: `/customers/affiliate/:id`,
    component: AffiliateDashboardDetails,
    exact: true,
    metadata: {
      title: 'Affiliate Dashboard Details',
      description
    }
  },
  {
    path: `/customers/affiliate`,
    component: AffiliateDashboard,
    exact: true,
    metadata: {
      title: 'Affiliate Dashboard',
      description
    }
  },
  {
    path: `/customers/analytics/:id`,
    component: AffiliateAnalyticsDetails,
    exact: true,
    metadata: {
      title: 'Customer Analytics Details',
      description
    }
  },
  {
    path: `/customers/analytics`,
    component: AffiliateAnalytics,
    exact: true,
    metadata: {
      title: 'Customer Analytics',
      description
    }
  },
  {
    path: `/coupons`,
    component: Coupons,
    exact: true,
    metadata: {
      title: 'Coupons',
      description
    }
  },
  {
    path: `/fraud/blacklist`,
    component: BlackList,
    exact: true,
    metadata: {
      title: 'Blacklists',
      description
    }
  },
  {
    path: `/fraud/whitelist`,
    component: WhiteList,
    exact: true,
    metadata: {
      title: 'Whitelist',
      description
    }
  },
  {
    path: `/fraud/sessions`,
    component: FraudSecurity,
    exact: true,
    metadata: {
      title: 'Fraud Sessions',
      description
    }
  },
  {
    path: `/fraud/dashboard`,
    component: FraudDashboard,
    exact: true,
    metadata: {
      title: 'Fraud Dashboard',
      description
    }
  },
  {
    path: `/fraud/disputes`,
    component: FraudDisputes,
    exact: true,
    metadata: {
      title: 'Fraud Disputes',
      description
    }
  },
  {
    path: `/fraud/audit`,
    component: FraudAudit,
    exact: true,
    metadata: {
      title: 'Fraud Audit',
      description
    }
  },
  {
    path: `/feedback/reply/:id`,
    component: ReplyToFeedback,
    exact: true,
    metadata: {
      title: 'Reply to Feedback',
      description
    }
  },
  {
    path: `/feedback`,
    component: AllFeedback,
    exact: true,
    metadata: {
      title: 'Feedback',
      description
    }
  },
  {
    path: `/appeals`,
    component: Appeal,
    exact: true,
    metadata: {
      title: 'Appeals',
      description
    }
  },
  {
    path: `/share-and-earn`,
    component: Referrals,
    exact: true,
    metadata: {
      title: 'Share and Earn',
      description
    }
  },
  {
    path: `/app-store`,
    component: AppStore,
    exact: true,
    metadata: {
      title: 'App Store',
      description
    }
  },
  {
    path: `/questions/:id`,
    component: Questions,
    exact: true,
    metadata: {
      title: 'Questions',
      description
    }
  },
  {
    path: `/questions`,
    component: Questions,
    exact: true,
    metadata: {
      title: 'Questions',
      description
    }
  },
  {
    path: `/developer/embed/integration`,
    component: EmbedIntegration,
    metadata: {
      title: 'Embed',
      description
    }
  },
  {
    path: `/developer/embed/buttons`,
    component: EmbedButtons,
    metadata: {
      title: 'Embed',
      description
    }
  },
  {
    path: `/developer/embed/customization`,
    component: EmbedCustomization,
    metadata: {
      title: 'Embed',
      description
    }
  },
  {
    path: `/developer/embed/styles`,
    component: EmbedStyles,
    metadata: {
      title: 'Embed',
      description
    }
  },
  {
    path: `/developer/embed/referrals`,
    component: EmbedReferrals,
    metadata: {
      title: 'Embed',
      description
    }
  },

  {
    path: `/developer/embed`,
    component: EmbedProduct,
    metadata: {
      title: 'Embed',
      description
    }
  },
  {
    path: `/developer/webhooks/all`,
    component: Webhooks,
    exact: true,
    metadata: {
      title: 'Webhooks',
      description
    }
  },
  {
    path: `/developer/webhooks/logs`,
    component: WebhookLogs,
    exact: true,
    metadata: {
      title: 'Webhook Logs',
      description
    }
  },
  {
    path: `/customization/domains`,
    component: Domains,
    exact: true,
    metadata: {
      title: 'Domain',
      description
    }
  },
  {
    path: `/customization/emails`,
    component: Emails,
    exact: true,
    metadata: {
      title: 'Emails',
      description
    }
  },
  {
    path: `/subscription`,
    component: SubscriptionDashboard,
    exact: true,
    metadata: {
      title: 'Subscription Dashboard',
      description
    }
  },
  {
    path: `/plan-n-pricing`,
    component: SubscriptionPlanPrice,
    exact: true,
    metadata: {
      title: 'Subscription Plan and Price',
      description
    }
  },
  {
    path: `/pro`,
    component: ProMembership,
    exact: true,
    metadata: {
      title: 'Pro Membership',
      description: 'Welcome to Pro Membership - Unlock enhanced features for your business growth'
    }
  },
  {
    path: `/business`,
    component: BusinessMembership,
    exact: true,
    metadata: {
      title: 'Business Membership',
      description: 'Welcome to Business Membership - Access enterprise-level features and unlimited potential'
    }
  }
]

export default dashboardRoutes